var FullScreen = {
	node :null,

	init: function() {
		if (
			document.fullscreenEnabled || 
			document.webkitFullscreenEnabled || 
			document.mozFullScreenEnabled ||
			document.msFullscreenEnabled
		) {
			FullScreen.node = $("<div id='fs'></div>");
			FullScreen.node.append(TPL.render("fullscreen-main", {}));
			$("#overlay").append(FullScreen.node);
			AppEvent.on(player, "placeReady", function(pe) { FullScreen.placeReady(pe);});

			$("#fs a").prop("title", TPL.lng("tips.clicktofullscreen", "Kliknij aby zmienić jakość"));
		}
	},

	placeReady: function(pe) {
		if (player.current.place_type == "panorama") { //  || player.current.place_type == "photo"
			$("#fs").show();
		} else {
			$("#fs").hide();
		}
	},

	toggle: function(event) {
		var i = $("body").get(0);

		if (event != undefined) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}		

		} else {

			if (i.requestFullscreen) {
				i.requestFullscreen();
			} else if (i.webkitRequestFullscreen) {
				i.webkitRequestFullscreen();
			} else if (i.mozRequestFullScreen) {
				i.mozRequestFullScreen();
			} else if (i.msRequestFullscreen) {
				i.msRequestFullscreen();
			}

			setTimeout(function() {
				player.currentView.reorient();
			}, 500);
		}
	}

}

PluginManager.add(FullScreen);